import React, {useCallback} from 'react';
import {StyleSheet, TouchableOpacity} from 'react-native';

import {AdjOOSData} from '@buncha/itemDetails/types/itemDetails';
import {Analytics} from '@buncha/config/analytics/analytics';
import BinIcon from '@buncha/components/core/icon/BinIcon';
import {Box} from '@buncha/components/core/view';
import DropItemModalBody from '../DropItemModalBody/DropItemModalBody';
import DropItemOOS from '../DropItemOOS/DropItemOOS';
import {EventType} from '@buncha/config/analytics/type';
import {H3Text} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import font from '@buncha/appStyles/style/font';
import {navigation} from '@buncha/config/navigation';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface DropItemProps {
  runId: number;
  orderItemId: number;
  showContactSheet: Function;
  showModal: boolean;
  showOOSModal: boolean;
  setShowModal: (value: boolean) => void;
  setShowOOSModal: (value: boolean) => void;
  isPermanentlyDropped: boolean;
  substitutionChoice?: string;
  isAdjacentOOSItem?: boolean;
  refreshBuyers: () => Promise<void>;
  isB2BStore: boolean;
  adjacentOOSData: AdjOOSData | undefined;
  catalogItemId: number | undefined;
  orderId: number;
  isCustomItem: boolean;
}

const DropItem: React.FC<DropItemProps> = props => {
  const theme = useColorThemeType('main');
  const {
    showModal,
    showOOSModal,
    setShowOOSModal,
    setShowModal,
    isPermanentlyDropped,
    substitutionChoice,
    isCustomItem,
  } = props;

  const closeOnlyModal = useCallback(() => {
    setShowModal(false);
    setShowOOSModal(false);
  }, [setShowModal, setShowOOSModal]);

  const closeModal = useCallback(() => {
    closeOnlyModal();
    if (showOOSModal) navigation.goBack();
  }, [closeOnlyModal, showOOSModal]);

  const handleContactSheet = useCallback(() => {
    Analytics.eventWithProps('Drop item for this user', {
      orderItemId: props?.orderItemId,
      type: EventType.cta,
    });
    props.showContactSheet();
  }, [props]);

  return (
    <React.Fragment>
      <DropItemModalBody
        orderItemId={props?.orderItemId}
        onClose={closeModal}
        open={showModal}
        isPermanentlyDropped={isPermanentlyDropped}
        substitutionChoice={substitutionChoice}
        isAdjacentOOSItem={props?.isAdjacentOOSItem}
        disableNavigation={!isCustomItem}
        refreshBuyers={props.refreshBuyers}
        catalogItemId={props.catalogItemId}
        orderId={props.orderId}
      />
      <DropItemOOS
        onClose={closeModal}
        open={showOOSModal}
        runId={props?.runId}
        closeOnlyModal={closeOnlyModal}
        adjacentOOSData={props?.adjacentOOSData}
      />
      <If condition={props?.isAdjacentOOSItem}>
        <TouchableOpacity
          style={[styles.container]}
          onPress={handleContactSheet}>
          <BinIcon viewBox="-5 -4 20 20" fill={theme?.background.red[100]} />
          <Box style={[styles.deleteBox]}>
            <H3Text
              style={[styles.nameTypo, {color: theme?.background.red[100]}]}>
              Remove item from customer's basket
            </H3Text>
          </Box>
        </TouchableOpacity>
      </If>
    </React.Fragment>
  );
};

export default DropItem;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexGrow: 1,
    paddingVertical: 10,
  },
  nameTypo: {
    ...font.FontSize.fontH6,
    textAlign: 'left',
  },
  deleteBox: {
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 2,
  },
});
